Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useScrollTo = void 0;
var _styles = require("../../styles");
var _reactNativeSafeAreaContext = require("react-native-safe-area-context");
var _reactNative = require("react-native-web");
var useScrollTo = exports.useScrollTo = function useScrollTo(_ref) {
  var scrollViewRef = _ref.scrollViewRef;
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    sizing = _STYLES$useStyles.sizing;
  var insets = (0, _reactNativeSafeAreaContext.useSafeAreaInsets)();
  var scrollTo = function scrollTo(y) {
    if (y && y > 0) {
      var _newY = y - sizing.topBarHeight - insets.top;
      if (scrollViewRef != null && scrollViewRef.current) {
        scrollViewRef.current.scrollTo({
          y: _newY,
          animated: true
        });
      } else if (_reactNative.Platform.OS === 'web') {
        window.scrollTo({
          top: _newY,
          behavior: 'smooth'
        });
      }
    }
  };
  return {
    scrollTo: scrollTo
  };
};